// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"826d8b85","737":"57aa1b39"}[chunkId] + ".chunk.js";
};